import React from 'react';
import globalStyles from '../../styles/exported.module.scss';

type EventIconProps = {
  month?: string;
  day?: string;
  className?: string;
};

const EventIcon: React.FC<EventIconProps> = ({ month = 'MAR', day = '1', className }) => {
  return (
    <svg
      width="148.68967"
      height="265.95322"
      viewBox="0 0 148.68967 265.95322"
      fill="none"
      version="1.1"
      id="svg2"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <defs id="defs2" />
      <text
        x="75"
        y="32"
        dominantBaseline="middle"
        textAnchor="middle"
        fontSize="60"
        fontWeight="bold"
        fill="#333333"
        id="text1"
      >
        {month}
      </text>
      <path
        d="m 6.4361811,192.93199 v 49.89075 c 0,11.80914 5.8087389,21.38174 12.9741419,21.38174 H 131.85288 c 7.1656,0 12.97415,-9.5726 12.97415,-21.38174 v -49.89075 z"
        fill={globalStyles.bdSecondaryPurple}
        id="path2"
        style={{ strokeWidth: 5.5519 }}
      />
      <rect
        x="3.7877755"
        y="78.97699"
        width="141.11412"
        height="183.18848"
        rx="13.229447"
        fill="#ffffff"
        stroke="#333333"
        strokeWidth="7.57555"
        id="rect2"
        style={{ opacity: 1, fill: 'none', stroke: '#000000', strokeOpacity: 1 }}
      />
      <ellipse
        cx="32.290199"
        cy="96.374008"
        fill="#333333"
        id="circle1"
        rx="8.9778509"
        ry="8.3534164"
        style={{ strokeWidth: 4.33 }}
      />
      <ellipse
        cx="115.60187"
        cy="95.947952"
        fill="#333333"
        id="circle2"
        rx="8.9778509"
        ry="8.3534164"
        style={{ strokeWidth: 4.33 }}
      />
      <text x="73" y="150" dominantBaseline="middle" textAnchor="middle" fontSize="72" fill="#333333" id="text2">
        {day}
      </text>
      <rect
        style={{
          fill: '#686868',
          fillOpacity: 1,
          stroke: '#000000',
          strokeWidth: 0.860712,
          strokeLinecap: 'round',
          strokeDasharray: 'none',
          strokeOpacity: 1,
          paintOrder: 'markers fill stroke',
        }}
        id="rect3"
        width="7.8388162"
        height="23.982506"
        x="29.921984"
        y="70.989182"
      />
      <rect
        style={{
          fill: '#686868',
          fillOpacity: 1,
          stroke: '#000000',
          strokeWidth: 0.868569,
          strokeLinecap: 'round',
          strokeDasharray: 'none',
          strokeOpacity: 1,
          paintOrder: 'markers fill stroke',
        }}
        id="rect3-1"
        width="7.8306775"
        height="24.447432"
        x="114.02914"
        y="70.559952"
      />
      <path
        style={{
          fill: 'none',
          fillOpacity: 1,
          stroke: '#000000',
          strokeWidth: 2.63736,
          strokeLinecap: 'round',
          strokeDasharray: 'none',
          strokeOpacity: 1,
          paintOrder: 'markers fill stroke',
        }}
        d="M 4.0107781,192.90211 141.35763,192.41662"
        id="path3"
      />
    </svg>
  );
};

export default EventIcon;
